var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _polygon;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgFoldingTables = function SvgFoldingTables(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "folding_tables",
    viewBox: "0 0 600 600",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.82,
    y: 200.69,
    width: 583.69,
    height: 69.29,
    fill: "#16a99e"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 50.22,
    y: 269.98,
    width: 500.35,
    height: 22.28,
    fill: "#015e85"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 32.51,
    y: 375.49,
    width: 500.35,
    height: 22.28,
    transform: "translate(188.41 -82.95) rotate(24.82)",
    fill: "#015e85"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 136.16,
    y: 339.4,
    width: 335.93,
    height: 22.28,
    transform: "translate(175.24 -95.28) rotate(24.82)",
    fill: "#015e85"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 69.5,
    y: 375.49,
    width: 500.35,
    height: 22.28,
    transform: "translate(772.12 603.35) rotate(155.18)",
    fill: "#015e85"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 130.27,
    y: 339.4,
    width: 335.93,
    height: 22.28,
    transform: "translate(716.07 543.52) rotate(155.18)",
    fill: "#015e85"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "591.51 201.04 7.82 201.04 135.14 131.75 473.92 131.75 591.51 201.04",
    fill: "#93b847"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFoldingTables, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/folding_tables.94ff414b.svg";
export { ForwardRef as ReactComponent };